export enum StatusTypes {
    SET_ADD_QUIZ_BUTTON_STATUS = 'SET_ADD_QUIZ_BUTTON_STATUS',
    SET_HAMBURGER_STATUS = 'SET_HAMBURGER_STATUS',
    SET_SERVER_STATUS = 'SET_SERVER_STATUS'
};